export var defaultFetchOptions = {
    method: 'GET',
    headers: {
        Accept: 'application/json'
    }
};
//# sourceMappingURL=types.js.map